module.exports = __webpack_public_path__ + "img/marissa_and_jp.33ca1652.jpg";